import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
	const section = document.querySelector('.service-expertise');
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!section || reduceMotion) {
		return;
	}

	const layers = section.querySelectorAll('.service-expertise__layer-image');
	const labels = section.querySelectorAll('.service-expertise__label');
	const labelCopies = section.querySelectorAll('.service-expertise__label-copy');
	const labelLines = section.querySelectorAll('.service-expertise__label-line');
	const labelDots = section.querySelectorAll('.service-expertise__label-dot');
	const button = section.querySelector('.service-expertise__button');

	if (!layers.length) {
		return;
	}

	section.classList.add('is-expertise-ready');

	const timeline = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			start: 'top 76%',
			end: 'center 34%',
			scrub: 1,
		},
	});

	const collapsedOffsets = [150, 100, 50, 0, -55, -115, -180];

	layers.forEach((layer, index) => {
		gsap.set(layer, {
			y: collapsedOffsets[index] || 0,
			opacity: 0,
			scale: 0.96,
		});
	});

	gsap.set(labels, {
		opacity: 0,
	});

	gsap.set(labelCopies, {
		opacity: 0,
	});

	labels.forEach((label) => {
		const isLeft = label.classList.contains('service-expertise__label--left');
		const copy = label.querySelector('.service-expertise__label-copy');
		const line = label.querySelector('.service-expertise__label-line');
		const dot = label.querySelector('.service-expertise__label-dot');

		if (copy) {
			gsap.set(copy, {
				x: isLeft ? -18 : 18,
			});
		}

		if (line) {
			gsap.set(line, {
				scaleX: 0,
				transformOrigin: isLeft ? 'right center' : 'left center',
			});
		}

		if (dot) {
			gsap.set(dot, {
				opacity: 0,
				scale: 0,
			});
		}
	});

	if (button) {
		gsap.set(button, {
			opacity: 0,
			y: 24,
		});
	}

	timeline.to(layers, {
		opacity: 1,
		scale: 1,
		duration: 0.25,
		stagger: {
			each: 0.035,
			from: 'end',
		},
	});

	layers.forEach((layer, index) => {
		timeline.to(
			layer,
			{
				y: 0,
				duration: 0.75,
				ease: 'none',
			},
			0.08
		);
	});

	timeline.to(labels, { opacity: 1, duration: 0.01 }, 0.3);
	timeline.to(labelLines, {
		scaleX: 1,
		duration: 0.24,
		stagger: 0.025,
		ease: 'power1.out',
	}, 0.34);
	timeline.to(labelDots, {
		opacity: 1,
		scale: 1,
		duration: 0.18,
		stagger: 0.025,
		ease: 'back.out(2)',
	}, 0.42);
	timeline.to(labelCopies, {
		opacity: 1,
		x: 0,
		duration: 0.26,
		stagger: 0.025,
		ease: 'power1.out',
	}, 0.44);

	if (button) {
		timeline.to(
			button,
			{
				opacity: 1,
				y: 0,
				duration: 0.25,
			},
			0.52
		);
	}
});
